import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import Toolbar from "../Toolbar/Toolbar";
import SideDrawer from "../SideDrawer/SideDrawer";
import { Sitemap, Logout, OnboardingModal, WhatsNewModal, DirtyStateNavModal } from "../Modals";
import useAdmin from "../../hooks/useAdmin";
import useAdminStore from "../../stores/useAdminStore";

const Header = (props) => {
  const {
    user,
    isLineManager,
    setObjectivesFilters,
    logout,
    isFirstLogin,
    setFirstLogin,
    isSecondScreen,
    setIsSecondScreen,
    updateUser,
    isDirtyForm,
    setIsDirtyForm,
    navModalProps,
    setNavModalProps,
    isWhatsNewModalOpen,
    isOnboardingModalOpen,
    setIsOnboardingModalOpen,
    setIsWhatsNewModalOpen,
  } = props;
  useAdmin(user?.isAdmin);
  const isAdmin = useAdminStore((state) => state.isAdmin);
  const history = useHistory();
  const [isSideDrawerOpen, setIsSideDrawerOpen] = useState(false);
  const [isSitemapModalOpen, setIsSitemapModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const toggleSideDrawer = () => {
    setIsSideDrawerOpen(!isSideDrawerOpen);
  };

  const toggleSitemapModal = () => {
    setIsSitemapModalOpen(!isSitemapModalOpen);
  };

  const toggleLogoutModal = () => {
    setIsLogoutModalOpen(!isLogoutModalOpen);
  };

  const logoutAndClearFilters = () => {
    setObjectivesFilters("dueDate", "");
    setObjectivesFilters("page", 1);
    setObjectivesFilters("pageSize", 5);
    setObjectivesFilters("status", "");
    logout();
  };

  const confirmLogoutModal = () => {
    setIsLogoutModalOpen(false);
    logoutAndClearFilters();
  };

  const { hasViewedWhatsNew } = user || false;

  useEffect(() => {
    if (!hasViewedWhatsNew) {
      setIsWhatsNewModalOpen(true);
    } else {
      setIsWhatsNewModalOpen(false);
    }
  }, [hasViewedWhatsNew]);

  useEffect(() => {
    if (isFirstLogin) {
      setIsOnboardingModalOpen(true);
    } else {
      setIsOnboardingModalOpen(false);
    }
  }, [isFirstLogin]);

  const onCloseNavModal = () => {
    setNavModalProps({ show: false });
  };

  const renderDirtyNavModal = (navPath, closeExisitingModal) => {
    if (closeExisitingModal) {
      closeExisitingModal();
    }
    setNavModalProps({ show: true, navPath });
  };

  const onConfirmNavModal = () => {
    onCloseNavModal();
    history.push(navModalProps.navPath);
  };

  const location = useLocation();

  useEffect(() => {
    setIsDirtyForm(false);
  }, [location]);

  return (
    <>
      <Toolbar
        openSitemapModal={toggleSitemapModal}
        openLogoutModal={toggleLogoutModal}
        drawerToggleHandler={toggleSideDrawer}
        user={user}
        isLineManager={isLineManager}
        setObjectivesFilters={setObjectivesFilters}
        isDirtyForm={isDirtyForm}
        renderDirtyNavModal={renderDirtyNavModal}
      />
      <SideDrawer
        openSitemapModal={toggleSitemapModal}
        openLogoutModal={toggleLogoutModal}
        show={isSideDrawerOpen}
        close={toggleSideDrawer}
        user={user}
        isLineManager={isLineManager}
        setObjectivesFilters={setObjectivesFilters}
        isDirtyForm={isDirtyForm}
        renderDirtyNavModal={renderDirtyNavModal}
      />
      <Sitemap
        show={isSitemapModalOpen}
        isLineManager={isLineManager}
        close={toggleSitemapModal}
        setObjectivesFilters={setObjectivesFilters}
        isDirtyForm={isDirtyForm}
        renderDirtyNavModal={renderDirtyNavModal}
      />
      <Logout show={isLogoutModalOpen} close={toggleLogoutModal} confirm={confirmLogoutModal} />
      {!isAdmin && (
        <>
          <WhatsNewModal
            isSecondScreen={isSecondScreen}
            setIsSecondScreen={setIsSecondScreen}
            isWhatsNewModalOpen={isWhatsNewModalOpen}
            setIsWhatsNewModalOpen={setIsWhatsNewModalOpen}
            user={user}
            updateUser={updateUser}
          />
          <OnboardingModal
            isSecondScreen={isSecondScreen}
            setIsSecondScreen={setIsSecondScreen}
            isOnboardingModalOpen={isOnboardingModalOpen}
            setIsOnboardingModalOpen={setIsOnboardingModalOpen}
            setFirstLogin={setFirstLogin}
            user={user}
            updateUser={updateUser}
          />
        </>
      )}
      <DirtyStateNavModal
        show={navModalProps.show}
        close={onCloseNavModal}
        confirm={onConfirmNavModal}
      />
    </>
  );
};

export default Header;
